import * as React from "react";
import { KMainFunctions } from "../../shared/utility/main-functions";

/**
 * The wordmark at the top of every auth screen.
 *
 * The Kuika asset is multicolour art — blue tile, white glyph, and a wordmark baked in at
 * #122C4B — so it cannot be recoloured as a KuikaSvg mask, and on the dark ground the
 * wordmark disappears entirely. The dark variant is therefore a second asset, swapped in
 * CSS rather than in JS so the choice lands with the pre-paint theme restore instead of
 * flashing on first render.
 */
export const AuthLogo: React.FC = () => {
  const isMainAI: boolean = KMainFunctions.isMainAI();

  if (isMainAI) {
    // Height is left to the asset: it is 124x39.8, and the fixed 36 some call sites used
    // to pass squashed it.
    return <img className="auth-logo" src="/assets/main-ai/main-logo.svg" width={124} alt="Main AI" />;
  }

  return (
    <>
      <img
        className="auth-logo auth-logo--light"
        src="images/common/kuika-logo-text.svg"
        width={124}
        height={36}
        alt="Kuika"
      />
      <img
        className="auth-logo auth-logo--dark"
        src="images/common/kuika-logo-text-dark.svg"
        width={124}
        height={36}
        alt="Kuika"
      />
    </>
  );
};
